<template>
  <van-popup
    v-model="selectArea"
    get-container="body"
    class="popup-area"
    position="bottom"
    :safe-area-inset-bottom="true"
    :close-on-click-overlay="false"
    @click-overlay="close"
  >
    <div class="title"><i class="iconfont-new icon-a-guanbi3x" @click="close" />请选择地区</div>
    <div class="address">
      <div
        v-for="i in 3"
        :key="i"
        :class="['address-name',{'cur':step===i}]"
        @click="unCk(i)"
      >
        {{ getAreaText(i) }}
      </div>
    </div>
    <div class="address-list">
      <div
        v-for="item in list[step]"
        :key="item.id"
        :class="addressClass(item.id)"
        @click="ck(item)"
      >{{ item.areaName }}</div>
    </div>
  </van-popup>
</template>

<script>
import { getAreaByPid } from '@/api/common.js'
import { deepClone } from '@/utils'

const keyMap = {
  1: 'province',
  2: 'city',
  3: 'area'
}
export default {
  name: 'AreaBox',
  props: ['selectArea'],
  data() {
    return {
      list: {
        1: [],
        2: [],
        3: []
      },
      step: 1,
      province: null,
      city: null,
      area: null
    }
  },
  // computed: {

  // },
  async created() {
    await this.getAreaList(0)
  },
  methods: {
    addressClass(id) {
      const { step } = this
      const t = this[keyMap[step]]
      return `address-item${t && t.id === id ? ' cur' : ''}`
    },
    getAreaText(val) {
      const { province, step, city, area } = this
      if (val === 1) return province && province.areaName || '请选择'
      if (val === 2) return step === 1 ? '' : (city && city.areaName || '请选择')
      if (val === 3) return step !== 3 ? '' : (area && area.areaName || '请选择')
    },
    unCk(index) {
      for (let i = 3; i >= index; i--) {
        this.$set(this, keyMap[i], null)
      }
      this.step = index
    },
    ck(obj) {
      const item = deepClone(obj || {})
      const { step, province, city } = this
      const { id } = item
      if (id === 0) {
        // 选择了全省或全国或者全市
        for (let i = 3; i > step; i--) {
          this.$set(this, keyMap[i], null)
        }
      }
      if (step === 3 || id === 0) {
        this.$set(this, keyMap[step], item)
        const { province, city, area } = this
        this.$listeners.select({ province, city, area })
        this.close()
        return
      }
      if (step === 1) {
        if (province && province.id === id) return
        this.province = item
      } else if (step === 2) {
        if (city && city.id === id) return
        this.city = item
      }
      this.step++
      this.getAreaList(id)
    },
    async getAreaList(parentId) {
      this.selectArea && this.$toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '加载中...'
      })
      try {
        const res = await getAreaByPid({ parentId }) || []
        const { step } = this
        this.$set(this.list, step, res)
      } catch (error) {
        console.error('getAreaList,', error)
      }
      this.selectArea && this.$toast.clear()
    },
    close() {
      this.$emit('update:selectArea', false)
    }
  }
}
</script>

<style lang="less" scoped>
.popup-area{
  height: 60%;
  width: 100%;
  border-radius:20px 20px 0 0 ;
  display: flex;
  flex-direction: column;
}
.title{
  flex-shrink: 0;
  flex-grow: 0;
  height: 88px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: PingFangSC-Regular;
  font-size: 34px;
  color: #222222;
  position: relative;
  .iconfont-new{
    position: absolute;
    left:30px;
    color: #999;
  }
}
.address{
  flex-shrink: 0;
  flex-grow: 0;
  border-top: 10px solid #f5f5f5;
  border-bottom: 1px solid #f5f5f5;
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .address-name{
    display: flex;
    width: 33.33%;
    justify-content: center;
    font-family: PingFangSC-Regular;
    font-size: 28px;
    color: #222222;
    position: relative;
    height: 100%;
    align-items: center;
  }
  .cur{
    color: #33B157;
    &::after{
      content: ' ';
      background: #33B157;
      border-radius: 3px;
      position: absolute;
      width: 42px;
      height: 6px;
      bottom: 0;
    }
  }
}
 .address-list{
  overflow-y: scroll;
  .cur{
    color: #33B157;
  }
 }
.address-item{
  height: 98px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: PingFangSC-Regular;
  font-size: 30px;
  color: #222222;
  letter-spacing: 0;
  border-bottom:  1px solid #f5f5f5;
}

.address-item:last-child{
   border-bottom: none
}
</style>
